<template>
  <el-container id="userInvoiceDetails" class="content-aside">
    <!-- Main Content -->
    <el-main class="cpl-main">
      <div class="invoice-details-wrapper hide-scrollbar">
        <div v-if="invoiceDetails !== null" :gutter="0" class="main-content-row inv-content">
          <div class="logo"></div>
          <div class="invoice-number">{{ `${$t('label.invoice', 1)} #${invoiceDetails.invoiceId}`}}</div>
          <div class="invoice-date">
            {{invoiceDetails._edit.billingDate}}
          </div>

          <div class="user-details">
            <template v-if="userInfo !== null">
              <div class="name">{{`${userInfo.address.firstName} ${userInfo.address.lastName}`}}</div>
              <div v-if="!!userInfo.address.companyName" class="company">{{userInfo.address.companyName}}</div>
              <div class="address">{{`${userInfo.address.streetNumber}, ${userInfo.address.city}, ${userInfo.address.country}`}}</div>
              <div v-if="userInfo.address._edit.showVat" class="vat">
                {{ `${$t('label.vat')} ${userInfo.address.VAT}`}}
            </div>
            </template>
          </div>

          <table class="invoice-details-table">
            <thead>
              <tr>
                <th>{{$t('label.plan', 1)}}</th>
                <th>{{$t('label.player', 1)}}</th>
                <th>{{invoiceDetails._edit.billingMonth}}</th>
                <th>{{$t('label.price')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, indx) in invoiceDetails._edit.items" :key="indx">
                <td>{{item.plan}}</td>
                <td>{{item.player}}</td>
                <td>{{item.periodOfBilling}}</td>
                <td>{{item.price}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="4"></th>
              </tr>
              <tr>
                <th colspan="4">
                  <div class="item subtotal">
                    <div class="label">{{$t('label.subtotal')}}</div>
                    <div class="value">{{invoiceDetails._edit.subtotalWithCurrency}}</div>
                  </div>
                  <div class="item vat">
                    <div class="label">{{`${$t('label.vat')} ${invoiceDetails._edit.vatInPercentWithLabel}`}}</div>
                    <div class="value">{{invoiceDetails._edit.vatWithCurrency}}</div>
                  </div>
                  <div class="item total">
                    <div class="label">{{$t('label.total')}}</div>
                    <div class="value">{{invoiceDetails._edit.amountWithCurrency}}</div>
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>

          <div class="inv-details-footer">
            <div class="item company">{{company}}</div>
            <div class="item address">{{companyAddress}}</div>
            <div v-if="vat" class="item vat">{{`VAT: ${vat}`}}</div>
            <div v-if="hasTermsOfSale" class="item terms-and-conditions" @click="$utils.downloadDocument({ url: '/static/docs/SpinetiX-General-Terms-and-Conditions-of-Sale.pdf', label: 'SpinetiXGeneral-Terms-and-Conditions-of-Sale.pdf'})">{{`${company} TERMS & CONDITIONS`}}</div>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script src="./user-invoice-details.js"></script>
<style lang="scss" src="./user-invoice-details.scss"></style>
